const LEGACY_CLAIMED_BY_DISPLAY_NAMES: Record<string, string> = {
  "AR Scopes": "Adventures Relief",
}

export function getClaimedByDisplayName(value: unknown): string {
  if (typeof value !== "string") return ""
  const trimmed = value.trim()
  return LEGACY_CLAIMED_BY_DISPLAY_NAMES[trimmed] ?? trimmed
}

export function normalizeClaimedByForDisplay(value: unknown): string {
  return getClaimedByDisplayName(value).toLowerCase()
}
